import User from './user.vue'
import ListUser from './list-user.vue'
export default {
  path: '/user',
  meta: {
    nav: {
      icon: 'people',
      managementRoute: true,
      role_required: 'api_editor',
      childDefault: true // grab first child as main route
    },
    breadCrumb: 'User'
  },
  component: User,
  children: [
    {
      path: '',
      name: 'users',
      meta: {
        breadCrumb: 'List'
      },
      component: ListUser
    }
  ]
}
